import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-distribute-run',
  templateUrl: './distribute-run.component.html',
  styleUrls: ['./distribute-run.component.scss']
})
export class DistributeRunComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
